import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { useMMDispatchActions, useMMSelector } from './withOwnReduxStore';
import { selectors } from '../../Stream';
import { getCommissionStreamId } from '../helpers';
import { getCommissions } from '../selectors';
import { fetchMoreCommissions } from '../actions';
const mapStateToProps = (state)=>{
    const streamId = getCommissionStreamId();
    const commissions = getCommissions(state);
    return {
        commissions,
        isFetchingCommissions: selectors.isFetching(state, streamId),
        isCommissionStreamInitialized: selectors.isInitialized(state, streamId),
        hasMoreCommissions: selectors.hasMore(state, streamId)
    };
};
export const useCommissions = ()=>_object_spread({}, useMMSelector(mapStateToProps), useMMDispatchActions({
        fetchMoreCommissions
    }));

//# sourceMappingURL=withCommissions.js.map